// ===================================================
// vBlock summary — the existing vb_blocks table made visible (Rule 26)
// ===================================================
// vb_blocks is the OLD rendering mechanism (VBlockShell, /dashboard/admin/
// vblock-test): one row per display block, hanging off a vb_records row via
// record_id. It is NOT the synced-content contract of DEC-0360 — that one is
// docs-only and has no table to read yet (vb_records has no active_version_id).
//
// Measured 06.09.2026: 57 rows · 3 types (heading / properties / paragraph) ·
// 21 records · last touched 24.08.2026. The board shows counts per type and
// the number of distinct records, nothing else — a read-only pulse, not a UI.
// supabase-js has no `group by`, so rows come raw and are reduced here.

export type BlockRow = {
  type: string | null;
  record_id: string | null;
  updated_at: string | null;
};

export type BlockTypeCount = {
  type: string;
  blocks: number;
  records: number;
};

export type BlockSummary = {
  total: number;
  records: number;
  last_updated: string | undefined;
  by_type: BlockTypeCount[];
};

export function summarizeBlocks(rows: BlockRow[]): BlockSummary {
  const perType = new Map<string, { blocks: number; records: Set<string> }>();
  const allRecords = new Set<string>();
  let last: string | undefined;

  for (const r of rows) {
    const type = r.type ?? "(ללא סוג)";
    const cur = perType.get(type) ?? { blocks: 0, records: new Set<string>() };
    cur.blocks += 1;
    if (r.record_id) {
      cur.records.add(r.record_id);
      allRecords.add(r.record_id);
    }
    perType.set(type, cur);
    if (r.updated_at && (!last || r.updated_at > last)) last = r.updated_at;
  }

  const by_type = [...perType.entries()]
    .map(([type, v]) => ({ type, blocks: v.blocks, records: v.records.size }))
    // most blocks first; ties broken by name so the order is stable
    .sort((a, b) => b.blocks - a.blocks || a.type.localeCompare(b.type));

  return { total: rows.length, records: allRecords.size, last_updated: last, by_type };
}
